import SMBookMarketTable from './SMBookMarketTable';

const TableWrapper = ({  data, showAction, handleDeleteAction }) => {

    return (
        <div className="table-responsive">
            <div id="dataTable_wrapper" className="dataTables_wrapper dt-bootstrap4">
                <div className="">
                    <div className="">
                        <SMBookMarketTable data={data} showAction={showAction} handleDeleteAction={handleDeleteAction} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TableWrapper;
